module.exports = __webpack_public_path__ + "img/20191209_112125-1.9e2fc7bc.jpg";